import React, { Fragment, useState } from "react";
import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import PencilOutline from "mdi-material-ui/PencilOutline";
import DeleteOutline from "mdi-material-ui/DeleteOutline";

import DialogModal from "@core/components/dialogmodal";
import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import ImageModal from "@core/components/imagemodal";
import UserModal from "@core/components/usermodal";
import { isPermissionAllow } from "@core/utils/IsPermissionAllow";

const renderClient = (params) => {
  const { row } = params;
  if (row.image) {
    return <img alt="img" src={`${row.image}`} width="40px" height="40px" />;
  }
};

const BusinessDataList = (props) => {
  const {
    handleDeleteModal,
    deleteOpen,
    businessList,
    pageSize,
    searchText,
    pageNumber,
    setPageSize,
    setSearchText,
    setPageNumber,
    totalRecord,
    fetchUserProfile,
    profileList,
    handleOpen,
    permission,
    role,
  } = props;

  const [openImage, setOpenImage] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [openUserModal, setOpenUserModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteId, setDeleteId] = useState("");

  const handleImageModal = (url) => {
    setImageUrl(url);
    setOpenImage(true);
  };

  const handleUserModal = (u_id) => {
    setOpenUserModal(!openUserModal);
    if (!openUserModal) {
      fetchUserProfile(u_id);
    }
  };

  const handleEdit = (id) => {
    handleOpen("edit", id);
  };

  const handleDelete = (id) => {
    handleDeleteModal();
    setDeleteId(id);
  };

  const handleClose = () => {
    setOpenImage(false);
    if (openUserModal) {
      setOpenUserModal(false);
    }
  };

  const columns = [
    {
      flex: 0.5,
      minWidth: 80,
      field: "index",
      headerName: "index",
    },
    {
      flex: 1,
      minWidth: 130,
      field: "user_name",
      headerName: "user name",
      renderCell: ({ row }) => {
        return (
          <Box
            onClick={() => handleUserModal(row.user_id)}
            sx={{ flexDirection: "column", display: "flex" }}
          >
            <Typography
              sx={{
                fontSize: "0.95rem !important",
                cursor: "pointer",
                color: "blue",
              }}
            >
              {row.user_name}
            </Typography>
            <Box sx={{ height: 1.7, backgroundColor: "blue", width: "100%" }} />
          </Box>
        );
      },
    },
    {
      flex: 1,
      minWidth: 130,
      field: "business_name",
      headerName: "business name",
    },
    {
      flex: 1,
      minWidth: 200,
      field: "email",
      headerName: "email",
    },
    {
      flex: 1,
      minWidth: 150,
      field: "phone_no",
      headerName: "phone",
      renderCell: ({ row }) => {
        return (
          <Box>
            {row?.country_code && row?.phone_no && (
              <Typography sx={{ fontSize: "0.92rem !important" }}>
                +{row.country_code}-{row.phone_no}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      flex: 1,
      minWidth: 130,
      field: "business_category_name",
      headerName: "category",
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: "0.95rem !important" }}>
            {params.row.business_category_name}
          </Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "website",
      headerName: "website",
    },
    {
      flex: 1,
      minWidth: 130,
      field: "fb_id",
      headerName: "facebook",
    },
    {
      flex: 1,
      minWidth: 130,
      field: "instagram_id",
      headerName: "Instagram",
    },
    {
      flex: 1,
      minWidth: 80,
      field: "image",
      headerName: "Image",
      renderCell: (params) => {
        return (
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => handleImageModal(params.row.image)}
          >
            {renderClient(params)}
          </Box>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 100,
      field: "action",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((permission.edit && role === "2") || role === "1") && (
                <IconButton onClick={() => handleEdit(row.id)}>
                  <PencilOutline fontSize="medium" />
                </IconButton>
              )}
              {((permission.delete && role === "2") || role === "1") && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize="medium" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },
    },
  ];
  const removeaction =
    !permission.edit && !permission.delete && role === "2"
      ? _.dropRight(columns)
      : columns;
  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
  };

  const assemList = businessList.map((data, index) => {

    return {
      index: index + pageSize * pageNumber + 1,
      id: data.id,
      user_id: data.user_id,
      user_name: data.user_name,
      business_name: data.business_name,
      business_category_id: data.business_category_id,
      business_details: data.business_details,
      address: data.address,
      business_category_name: data.business_category_name,
      business_category_icon: data.business_category_icon,
      email: data.email,
      phone_no: data.phone_no,
      website: data.website,
      fb_id: data.fb_id,
      instagram_id: data.instagram_id,
      image: data.image,
      country_code: data.country_code,
    };
  });

  return (
    <Fragment>
      <Card sx={{ width: "100%", overflowInline: "hidden" }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          columns={removeaction}
          rows={assemList}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50]}
          components={{ Toolbar: QuickSearchToolbar }}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          pagination
          rowCount={Number(totalRecord)}
          page={pageNumber}
          paginationMode="server"
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              value: searchText,
              clearSearch: () => handleSearch(""),
              onChange: (event) => handleSearch(event.target.value),
              handleOpen: () => handleOpen("add", ""),
              selectedRows: selectedRows,
              onClickDelete: () => handleDeleteModal(),
              title: isPermissionAllow(permission.edit, role)
                ? "Add Business"
                : "",
              multiDelete: isPermissionAllow(permission.delete, role),
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
        />
      </Card>

      {openImage && (
        <ImageModal
          open={openImage}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      )}

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows
            )
          }
        />
      )}

      {openUserModal && (
        <UserModal
          open={openUserModal}
          handleClose={handleClose}
          profileList={profileList}
        />
      )}
    </Fragment>
  );
};

export default BusinessDataList;
